import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { ISalesFilterData } from 'gen/ApiClient';

export const SalesFilterDataContext = React.createContext<ICacheContext<ISalesFilterData>>(undefined as any);
